module.exports = __webpack_public_path__ + "static/media/bg_mobile.d033f07e.jpg";